import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../../components/index.js';

import css from './LinkButton.module.css';

const VARIANT_CLASS = {
  primary: css.primary,
  secondary: css.secondary,
  ghost: css.ghost,
  outlineLight: css.outlineLight,
};

/**
 * Shared CTA button for the landing page.
 *
 * Renders a NamedLink when `name` (a route name) is given, otherwise a plain
 * anchor for `href`. Keeps all CTA styling and routing in one place.
 *
 * @param {Object} props
 * @param {string} [props.name] route name for NamedLink (e.g. 'NewListingPage')
 * @param {Object} [props.params] route params for NamedLink
 * @param {string} [props.href] external/plain href (used when no `name`)
 * @param {'primary'|'secondary'|'ghost'|'outlineLight'} [props.variant]
 * @param {boolean} [props.large]
 * @param {React.ReactNode} props.children
 */
const LinkButton = props => {
  const { name, params, href, variant = 'primary', large = false, className, children } = props;
  const classes = classNames(
    css.btn,
    VARIANT_CLASS[variant] || css.primary,
    { [css.large]: large },
    className
  );

  if (name) {
    return (
      <NamedLink name={name} params={params} className={classes}>
        {children}
      </NamedLink>
    );
  }
  return (
    <a href={href || '#'} className={classes}>
      {children}
    </a>
  );
};

export default LinkButton;
